import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueTobacco extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Tobacco',
      description: 'Most smokers start before they’re 18. Every day, more than 2,000 young Americans become daily smokers.',
      url: config.domain + config.routes.issueTobacco
    }
  }

  render() {
    return (
      <div styleName='page issue-tff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Tobacco</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              Smoking is a leading cause of preventable death
            </h2>
            <h3 styleName='issue-top-copy'>
              Most smokers start before they’re 18. Every day, more than 2,000 young Americans become daily smokers.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in tobacco</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    The World Health Organization describes tobacco as the most devastating, but preventable, epidemic of our time. Addressing the financing of tobacco companies—across lending, insurance and investment—is essential to comprehensive global tobacco control efforts.
                  </p>
                  <p>
                    Asset managers like Vanguard, BlackRock, and State Street are investing in tobacco – and they’re using workers’ retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing millions of dollars into tobacco producers.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Tobacco-promoting entertainment companies
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      There is scientific consensus that exposure to tobacco in movies causes kids to begin smoking. In 2012, the U.S. Surgeon General reviewed <Link to='https://www.ncbi.nlm.nih.gov/books/NBK99237/pdf/Bookshelf_NBK99237.pdf' title='Preventing Tobacco Use Among Youth and Young Adults: A Report of the Surgeon General' xstrong>extensive scientific literature</Link> and concluded that exposure to smoking on screen causes kids to smoke.
                    </p>
                    <p>
                      However, the Motion Picture Association of America, the trade group for the major studios that governs the U.S. movie rating system, has repeatedly refused to adopt the R-rating for smoking. None of the major movie studios are “Tobacco Free”. Many entertainment companies promote smoking by producing kid-rated movies that depict smoking.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#tobacco'}
                        title='Companies: Tobacco'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Offer tobacco-free retirement plan options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Company retirement plans should offer fund options that are sustainably invested and exclude tobacco producers.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionOfferSustainability}
                        title='Solution: Offer sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing tobacco.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
